import { useRestClient, RestSchemas } from '@/contexts/QueryProvider'
// import { json } from '@/catalog-apps/mock-data/data-assets/data-assets-summary-response-skills.json'
import { useAppContext } from '@/catalog-apps/hooks/useAppContext'

export type DataAssetSummaryResponse = RestSchemas['Messages.DataAssets.TDataAssetActivity']

// const mockData = json as DataAssetSummaryResponse[]

export function useGetDataAssets({
  appId: appIdProp,
  projectId: projectIdProp,
}: {
  appId?: number
  projectId?: number
}) {
  const { getDataAssetApiGetTemplateSummary } = useRestClient()
  const { appId: appIdContext, projectId: projectIdContext } = useAppContext()
  return getDataAssetApiGetTemplateSummary.useSuspenseQuery(
    { path: { applicationId: appIdProp || appIdContext!, projectId: projectIdProp || projectIdContext! } }
    // TODO: Remove mock data
    // { select: (_) => mockData }
  )
}

export function useInvalidateDataAssets() {
  const { getDataAssetApiGetTemplateSummary } = useRestClient()
  // const { appId, projectId } = useAppContext()
  // return () =>
  //   getDataAssetApiGetTemplateSummary.invalidateQueries({
  //     parameters: { path: { applicationId: appId!, projectId: projectId! } },
  //   })
  return () => getDataAssetApiGetTemplateSummary.invalidateQueries()
}
